const gradients = [
  ["#2563eb", "#10b981"],
  ["#0f766e", "#38bdf8"],
  ["#7c3aed", "#06b6d4"],
  ["#be123c", "#f59e0b"],
  ["#172033", "#2563eb"],
  ["#0f8a5f", "#84cc16"]
];

export const getInitials = (value = "User") => {
  const parts = String(value)
    .trim()
    .split(/\s|@/)
    .filter(Boolean);

  return (parts[0]?.[0] || "U").toUpperCase() + (parts[1]?.[0] || "").toUpperCase();
};

export const getAvatarGradientStyle = (value = "User") => {
  const seed = String(value).split("").reduce((sum, char) => sum + char.charCodeAt(0), 0);
  const [from, to] = gradients[seed % gradients.length];

  return {
    "--avatar-from": from,
    "--avatar-to": to
  };
};
